<form class="sign-in__form" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <h1 class="sign-in__hub-text">{{ appName }}</h1>
  <small class="sign-in__hub-slogan-text">
    Mais eficiência na gestão de benefícios
  </small>

  <hr class="w-25 mb-2" />
  <p>Entre com sua conta</p>

  <mat-form-field class="w-100">
    <mat-label>E-mail</mat-label>
    <input type="email" matInput formControlName="email" />
    <mat-error *ngIf="formGroup.get('email')?.hasError('required')">
      Este campo é obrigatório
    </mat-error>
    <mat-error *ngIf="formGroup.get('email')?.hasError('email')">
      Digite o e-mail corretamente
    </mat-error>
  </mat-form-field>

  <mat-form-field class="w-100">
    <mat-label>Senha</mat-label>
    <input
      [type]="showPassword ? 'text' : 'password'"
      matInput
      formControlName="password"
    />
    <button
      mat-icon-button
      matSuffix
      (click)="toggleShowPassword()"
      type="button"
    >
      <mat-icon color="primary">
        {{ showPassword ? "visibility" : "visibility_off" }}
      </mat-icon>
    </button>
    <mat-error>Este campo é obrigatório</mat-error>
  </mat-form-field>

  <button
    class="w-100"
    mat-flat-button
    color="primary"
    type="button"
    type="submit"
    [disabled]="isTryingToSignIn"
  >
    <span *ngIf="isTryingToSignIn">Entrando...</span>
    <span *ngIf="!isTryingToSignIn">Entrar</span>
  </button>
  <section class="sign-in__actions">
    <a routerLink="/autenticacao/recuperar-senha" class="default-hyper-link"
      >Esqueci minha senha</a
    >
  </section>
</form>
